import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { decodeUtf8 } from '@core/_utils/tools.utils';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'app-edit-editors',
    templateUrl: './edit-editors.component.html',
    styleUrls: ['./edit-editors.component.scss'],
})
export class EditEditorsComponent implements OnInit {
    public selectedEditor: any;

    @Input()
    public item: any;

    @Input()
    public customEditorList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    constructor(
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private api: ApiV6Service,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.selectedEditor = {};
    }

    ngOnInit() {
        this.getRequest(this.item.reference);
        this.commonService.checkReset();
    }

    private getRequest(aName) {
        let wEditor: any;
        wEditor = this.customEditorList.filter((item) => {
            return item.Information.Name === aName
        });
        if (wEditor) {
            this.selectedEditor.id = wEditor[0].id;
            this.selectedEditor.desc = this.getDescription(wEditor[0]);
            this.selectedEditor.displayValue = decodeUtf8(this.getDisplayValue(wEditor[0]));
            this.selectedEditor.useValue = decodeUtf8(this.getUseValue(wEditor[0]));
            this.selectedEditor.type = wEditor[0].Information.Type_;
            this.selectedEditor.name = wEditor[0].Information.Name;
        }
    }

    private getDescription(aItem) {
        if (Array.isArray(aItem.Information.Description)) {
            return '';
        } else {
            return aItem.Information.Description
        }
    }

    private getDisplayValue(aItem) {
        if (aItem.Information.Type_ === 'ComboCustom') {
            return aItem.ComboCustom.Show
        }
        if (aItem.Information.Type_ === 'Combo') {
            return aItem.Combo.Value
        }
    };

    private getUseValue(aItem) {
        if (aItem.Information.Type_ === 'ComboCustom') {
            return aItem.ComboCustom.Value
        }
        if (aItem.Information.Type_ === 'Combo') {
            return aItem.Combo.Value
        }
    };

    public async validate(aRequest) {
        let wRes: any;
        const wParams = this.formatRequest(aRequest);
        try {
            await lastValueFrom(this.api.execUrlAction('setcombo', wParams));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }

        try {
            wRes = await lastValueFrom(this.api.getCustomEditorlist());
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Get_Edt_KO'));
            return;
        }

        this.onValidate.emit({
            index: this.item.index,
            id: this.item.id,
            data: wRes.CustomEditorList.CustomEditor.filter((item) => {
                return item.Information.Name === this.item.reference
            })
        });
    }

    private formatRequest(aRequest) {
        let wRequest: {};
        if (aRequest.type === 'ComboCustom' ) {
            wRequest = {                
                CustomEditorName: aRequest.CustomEditorName,
                Values: aRequest.Values,
                Shows: aRequest.Shows,
            }            
        } else {
            wRequest = {
                CustomEditorName: aRequest.CustomEditorName,
                Values: aRequest.Values,
            }
        }
        return {
            cmbtype: aRequest.type,
            request: wRequest,
        }
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
